// src/config/index.tsx
import { mpSdk } from '@zcy/zlb-utils';
import React, { ReactNode, useState } from 'react';
import { EnvSchema } from './entities/envSchema';
import { anhui, slt, zlb } from './envConfig';

/* Context */
const ConfigContext = React.createContext<EnvSchema | undefined>(undefined);

/* Provider：放在 <App> 最外层 */
export function EnvConfigProvider({ children }: { children: ReactNode }) {
  const loadEnv = () => {
    if (mpSdk.env.isShulitong) return slt;
    if (mpSdk.env.isAnhui) return anhui;
    return zlb;
  };
  const [cfg] = useState<EnvSchema | undefined>(loadEnv());
  return <ConfigContext.Provider value={cfg}>{children}</ConfigContext.Provider>;
}

/* Hook：业务组件里直接拿配置 */
export function useEnvConfig(): EnvSchema {
  const ctx = React.useContext(ConfigContext);
  if (!ctx) throw new Error('useConfig 必须在 ConfigProvider 内使用');
  return ctx;
}
